import { useEffect, useRef, useState } from 'react'
import './playlist-view.scss'
import Modal from 'react-modal/lib/components/Modal'
import { useUpdatePlayerMutation } from 'api/api'
import PlaylistEditModal from './PlaylistEditModal/PlaylistEditModal'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import { cloneDeep, isEmpty } from 'lodash'
import PlaylistTree from '../../components/PlaylistEditor/PlaylistTree'
import PlaylistEditor from '../../components/PlaylistEditor/PlaylistEditor'
import GeneralModal from '../../components/GeneralModal/GeneralModal'

const PlaylistView = ({
  isLoading,
  isOutOfDate,
  playlist: originalPlaylistData,
  onSubmit,
  onEditTrack,
}) => {
  const [playlistData, _setPlaylistData] = useState(originalPlaylistData)
  const [playlistToPublish, setPlaylistToPublish] = useState(null)
  const openFoldersRef = useRef(null)

  const [updatePlayer, { isLoading: updatePlayerIsLoading }] =
    useUpdatePlayerMutation()

  const items = playlistData?.data || []
  const hasItems = items.length > 0

  useEffect(() => {
    if (
      playlistData === undefined ||
      originalPlaylistData.modified > playlistData.modified
    ) {
      _setPlaylistData(originalPlaylistData)
      return
    }

    const pendingChanges = originalPlaylistData?.data?.reduce((acc, cur) => {
      if (cur?.data?.pendingChanges) {
        acc[cur?.id] = 1
      } else {
        acc[cur?.id] = null
      }
      return acc
    }, {})

    if (!isEmpty(pendingChanges) && playlistData) {
      const existingData = cloneDeep(playlistData)
      existingData.data = existingData?.data?.map((playlist) => {
        if (pendingChanges[playlist.id] !== undefined) {
          return {
            ...playlist,
            data: {
              ...playlist.data,
              pendingChanges: pendingChanges[playlist.id],
            },
          }
        }
        return playlist
      })

      _setPlaylistData(existingData)
    }

    if (openFoldersRef.current === null && originalPlaylistData?.data) {
      openFoldersRef.current = originalPlaylistData?.data?.reduce(
        (acc, cur) => {
          const type = cur.id.slice(0, 1)
          if (type === 'g' && cur?.data?.open) {
            acc.push(cur.id)
          }
          return acc
        },
        [],
      )
    }
  }, [JSON.stringify(originalPlaylistData)])

  function setPlaylistData(data, flags) {
    onSubmit(data, flags)
    _setPlaylistData({ ...data })
  }

  function handlePublishChangesClick(node) {
    setPlaylistToPublish(node.id)
  }

  function handleConfirmPublishClick() {
    updatePlayer(playlistToPublish)
    setPlaylistToPublish(null)
  }

  return (
    <div className="playlist-view h-full">
      <PlaylistEditor
        values={playlistData}
        onChange={setPlaylistData}
        isLoading={isLoading}
        isOutOfDate={isOutOfDate}
        onEditTrack={onEditTrack}
        onPublishChangesClick={handlePublishChangesClick}
      />
      <GeneralModal
        isOpen={!!playlistToPublish}
        onRequestClose={() => setPlaylistToPublish(null)}
        title="Publish Playlist"
        buttons={[
          {
            text: 'Publish',
            className: 'button bg-pink hover:bg-pink-off',
            onClick: handleConfirmPublishClick,
          },
        ]}
      >
        <p>
          Are you sure you'd like to publish any pending changes? This will
          update any live players using this playlist.
        </p>
      </GeneralModal>
    </div>
  )
}

export default PlaylistView
